<template>
    <div class="mt-2">
        <div v-if="albums.length" class="flex flex-col gap-2">
            <div
                v-for="album in albums.slice(0, count)"
                :key="album.id"
                class="home-album-row flex items-center gap-3 rounded border border-slate-700/40 bg-slate-900/30 overflow-hidden"
                itemscope
                itemtype="http://schema.org/MusicAlbum"
            >
                <img
                    :ref="`img-${album.id}`"
                    class="w-14 h-14 object-cover flex-shrink-0"
                    :src="`/storage/music_albums/${album.lidarr_id}.webp`"
                    :alt="album.title"
                    @error="imageLoadError(album.id)"
                >
                <div class="min-w-0 flex-1 py-1 pr-2">
                    <p class="text-xs text-slate-400 truncate uppercase leading-tight" itemprop="byArtist">
                        {{ album.artist?.name }}
                    </p>
                    <h3 class="text-sm font-semibold text-slate-100 leading-tight truncate" itemprop="name">
                        {{ album.title }}
                    </h3>
                    <p class="text-xs text-slate-400 leading-tight" itemprop="datePublished">
                        {{ formatDate(album.release_date, 'MMM D, YYYY') }}
                    </p>
                </div>
            </div>
        </div>
        <div v-else class="w-full h-24 flex flex-wrap justify-center items-center text-center text-slate-400">
            No Upcoming Albums. Check Back Soon!
        </div>
    </div>
</template>

<script>
    import { formatDate } from '@/utils/Utilities';
    import { gsap } from 'gsap/all'

    export default {
        name: 'HomeUpcomingAlbums',
        props: {
            albums: {
                type: Array,
                default: () => [],
            },
            count: {
                type: Number,
                default: 5,
            },
        },
        mounted() {
            gsap.fromTo('.home-album-row',
                { y: 10, opacity: 0 },
                { y: 0, opacity: 1, stagger: .03, duration: .25 },
            )
        },
        methods: {
            formatDate,
            imageLoadError(id) {
                const im = this.$refs[`img-${id}`];
                if (im && im[0]) {
                    im[0].src = '/storage/recipes/no-image.jpg';
                }
            },
        },
    }
</script>

<style lang="postcss">
.home-album-row {
    opacity: 0;
}
</style>
